import { render, staticRenderFns } from "./CategoryContentRecipes.vue?vue&type=template&id=092f3373&scoped=true"
import script from "./CategoryContentRecipes.vue?vue&type=script&lang=js"
export * from "./CategoryContentRecipes.vue?vue&type=script&lang=js"
import style0 from "./CategoryContentRecipes.vue?vue&type=style&index=0&id=092f3373&prod&lang=scss&scoped=true"
import style1 from "./CategoryContentRecipes.vue?vue&type=style&index=1&id=092f3373&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f3373",
  null
  
)

export default component.exports